/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DataProductAssetInputDto = {
    type: DataProductAssetInputDto.type;
};

export namespace DataProductAssetInputDto {

    export enum type {
        STATIC = 'STATIC',
        DYNAMIC = 'DYNAMIC',
    }


}
